import React from "react"
import { MdLaunch } from "react-icons/md"

export default function BuildPreviewLink({ previewUrl, ...rest }) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={previewUrl}
      css={theme => ({
        display: `flex`,
        alignItems: `center`,
        fontSize: theme.fontSizes[1],
        textUnderlinePosition: `under`,
        textDecorationColor: theme.colors.grey[20],
        svg: {
          marginLeft: theme.space[2],
        },
      })}
      {...rest}
    >
      {previewUrl} <MdLaunch />
    </a>
  )
}
